import React, { useRef, useState } from "react";
import { UploadCloud, Loader2 } from "lucide-react";
import { uploadFile, formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function ImageUploader({ value, onChange, placeholder = "https://..." }) {
    const fileRef = useRef(null);
    const [uploading, setUploading] = useState(false);

    const handleFileChange = async (e) => {
        const file = e.target.files?.[0];
        if (!file) return;

        setUploading(true);
        try {
            const res = await uploadFile(file);
            // Assuming res.url contains the uploaded file URL (e.g. /api/uploads/xxx)
            // But we need to use process.env.REACT_APP_BACKEND_URL to make sure the URL is absolute
            const backendUrl = process.env.REACT_APP_BACKEND_URL || "";
            let fullUrl = res.url;
            if (fullUrl.startsWith("/")) {
                fullUrl = backendUrl + fullUrl;
            }
            onChange(fullUrl);
            toast.success("Image uploaded successfully");
        } catch (err) {
            toast.error(formatApiError(err.response?.data?.detail) || "Failed to upload image");
        } finally {
            setUploading(false);
            if (fileRef.current) fileRef.current.value = "";
        }
    };

    return (
        <div className="flex items-center gap-3 w-full">
            <input
                type="text"
                className="ainp flex-1"
                value={value || ""}
                onChange={(e) => onChange(e.target.value)}
                placeholder={placeholder}
            />
            <input
                type="file"
                ref={fileRef}
                onChange={handleFileChange}
                accept="image/*"
                className="hidden"
            />
            <button
                type="button"
                onClick={() => fileRef.current?.click()}
                disabled={uploading}
                className="flex-shrink-0 inline-flex items-center gap-2 px-4 py-2.5 rounded-lg bg-ink-800 border border-white/10 hover:bg-ink-700 text-sm font-medium text-white transition-colors disabled:opacity-50"
            >
                {uploading ? <Loader2 size={16} className="animate-spin" /> : <UploadCloud size={16} />}
                Upload
            </button>
        </div>
    );
}
